import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import addMembershipFlowReducer from "features/slices/addMembershipFlowSlice";
import authReducer from "features/slices/authSlice";
import buyFlowReducer from "features/slices/buyFlowSlice";
import loginFlowReducer from "features/slices/loginFlowSlice";
import reservationFlowReducer from "features/slices/reservationFlowSlice";
import shopPagePhaseTwoReducer from "features/slices/shopPagePhaseTwoSlice";
import tenantReducer from "features/slices/tenantSlice";
import themeReducer from "features/slices/themeSlice";
import ticketBundleReducer from "features/ticketBundle/ticketBundleSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    tenant: tenantReducer,
    theme: themeReducer,
    reservationFlow: reservationFlowReducer,
    buyFlow: buyFlowReducer,
    loginFlow: loginFlowReducer,
    addMembershipFlow: addMembershipFlowReducer,
    shopPagePhaseTwo: shopPagePhaseTwoReducer,
    ticketBundle: ticketBundleReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
